// Deliberately separate from raw process.env.PUBLIC_URL: that value must stay "/dashboard"
// (derived from "homepage" in package.json) because Auth0's redirect_uri depends on it matching
// what's registered in the Auth0 Application's Allowed Callback URLs, in every environment.
// Routing itself has a different requirement — in production the load balancer serves this app
// under /dashboard/*, but locally (npm start) there is no such prefix, so routes must match the
// bare root.
export const APP_BASE_PATH =
  process.env.NODE_ENV === 'development' ? '' : process.env.PUBLIC_URL || '';

export function getRouterPathname(): string {
  const base = APP_BASE_PATH;
  const path = window.location.pathname;
  if (base && path.startsWith(base)) {
    const rest = path.slice(base.length);
    return rest === '' ? '/' : rest;
  }
  return path;
}

export function appPath(pathWithOptionalQuery: string): string {
  let p = pathWithOptionalQuery;
  if (!p.startsWith('/')) {
    p = `/${p}`;
  }
  return `${APP_BASE_PATH}${p}`;
}
